import PageNotFound from "domain/PageNotFound";
import LandingPage from "domain/public/Landing/Page";
import { Routes, Route } from "react-router-dom";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/:place" element={<LandingPage />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;
